module.exports = __webpack_public_path__ + "media/components/footer/static/star-ab95bb1afff29bcc3fbda1ad32b985d0.png";